export const _en = {
    toggleDeleted: {
        label: ""
    },
    firstRow: {
        addButton: {
            label: "Add"
        },
        modal: {
            label: "Task category creation"
        }
    },
    secondRow: {
        addButon: {
            label: "Add"
        },
        modal: {
            label: "Task type creation"
        }
    },
    thirdRow: {
        tabs: {
            propertie: {
                label: "Properties"
            }
        },
        duplicateButton: {
            label: "Duplicate"
        },
        addButton: {
            label: "Create"
        },
        editButton: {
            label: "Edit"
        }
    },
    dialog: {
        new: {
            title: "New"
        },
        edit: {
            title: "Edit",
            buttons: {
                save: "Save",
                cancel: "Cancel"
            }
        },
        duplicate: {
            title: "Duplicate",
            buttons: {
                save: "Save",
                cancel: "Cancel"
            }
        },
        delete: {
            warningTitle: "Would you like to delete: {{item}} ?"
        }
    }
};

export const _fr = {
    toggleDeleted: {
        label: "Afficher les données archivées"
    },
    firstRow: {
        addButton: {
            label: "Catégorie d'une séance"
        },
        modal: {
            label: "Ajout d'une nouvelle catégorie d'une séance"
        }
    },
    secondRow: {
        addButton: {
            label: "Type de séance"
        },
        modal: {
            label: "Ajout d'un type de séance"
        }
    },
    dialog: {
        new: {
            title: "Ajout d'une catégorie de séance"
        },
        edit: {
            title: "Édition d'une catégorie de séance",
            buttons: {
                save: "Éditer",
                cancel: "Annuler"
            }
        },
        duplicate: {
            title: "Duplication d'une catégorie de séance",
            buttons: {
                save: "Dupliquer",
                cancel: "Annuler"
            }
        },
        delete: {
            warningTitle: "Voulez vous supprimer : {{item}} ?"
        }
    }
};